import React, { useState, useEffect } from 'react';
import styles from './UserManagement.module.css';

const Header = ({ onAddUser, departments = [], onAddDepartment, onDeleteDepartment }) => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [newUser, setNewUser] = useState({
    name: '',
    email: '',
    role: 'user',
    status: 'active',
    department: '',
    permissions: [],
    avatar: ''
  });
  const [newDepartment, setNewDepartment] = useState('');
  // Tema
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('theme') === 'dark');
  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
      localStorage.setItem('theme', 'dark');
    } else {
      document.body.classList.remove('dark-mode');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onAddUser({
      ...newUser,
      id: Date.now(),
      lastLogin: '-',
      createdAt: new Date().toISOString().split('T')[0],
      activities: []
    });
    setShowAddModal(false);
    setNewUser({
      name: '',
      email: '',
      role: 'user',
      status: 'active',
      department: '',
      permissions: [],
      avatar: ''
    });
  };

  return (
    <div className={styles.header}>
      <div className={styles.headerContent}>
        <h1 className={styles.title}>Kullanıcı Yönetimi</h1>
        <div className={styles.headerActions}>
          <button
            className={`${styles.button} ${styles.primaryButton}`}
            onClick={() => setShowAddModal(true)}
          >
            <i className="fas fa-plus"></i>
            Yeni Kullanıcı
          </button>
          <button
            className={styles.button}
            onClick={() => setDarkMode(d => !d)}
            title={darkMode ? 'Açık Tema' : 'Karanlık Tema'}
            style={{ marginLeft: 8 }}
          >
            <i className={darkMode ? 'fas fa-sun' : 'fas fa-moon'}></i>
          </button>
        </div>
      </div>

      {showAddModal && (
        <div className={styles.modal}>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <h2 className={styles.modalTitle}>Yeni Kullanıcı Ekle</h2>
              <button
                className={styles.closeButton}
                onClick={() => setShowAddModal(false)}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className={styles.formGroup}>
                <label className={styles.label} htmlFor="name">Ad Soyad</label>
                <input
                  type="text"
                  id="name"
                  className={styles.input}
                  value={newUser.name}
                  onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
                  required
                />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label} htmlFor="email">E-posta</label>
                <input
                  type="email"
                  id="email"
                  className={styles.input}
                  value={newUser.email}
                  onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
                  required
                />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label} htmlFor="department">Departman</label>
                <div style={{ display: 'flex', gap: 8 }}>
                  <select
                    id="department"
                    className={styles.select}
                    value={newUser.department}
                    onChange={(e) => setNewUser({ ...newUser, department: e.target.value })}
                    required
                  >
                    <option value="">Departman Seçin</option>
                    {departments.map(dep => (
                      <option key={dep} value={dep}>{dep}</option>
                    ))}
                  </select>
                  <input
                    type="text"
                    className={styles.input}
                    style={{ width: 120 }}
                    placeholder="Yeni"
                    value={newDepartment}
                    onChange={e => setNewDepartment(e.target.value)}
                  />
                  <button
                    type="button"
                    className={styles.button}
                    onClick={() => { onAddDepartment(newDepartment); setNewDepartment(''); }}
                    disabled={!newDepartment.trim()}
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
                <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {departments.map(dep => (
                    <span key={dep} style={{ background: '#f1f5f9', borderRadius: 8, padding: '2px 8px', display: 'flex', alignItems: 'center', gap: 4 }}>
                      {dep}
                      <button type="button" style={{ background: 'none', border: 'none', color: '#991b1b', cursor: 'pointer' }} onClick={() => onDeleteDepartment(dep)} title="Sil">
                        <i className="fas fa-times"></i>
                      </button>
                    </span>
                  ))}
                </div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label} htmlFor="role">Rol</label>
                <select
                  id="role"
                  className={styles.select}
                  value={newUser.role}
                  onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
                  required
                >
                  <option value="user">Normal Kullanıcı</option>
                  <option value="superuser">Süper Kullanıcı</option>
                  <option value="admin">Admin</option>
                </select>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label} htmlFor="status">Durum</label>
                <select
                  id="status"
                  className={styles.select}
                  value={newUser.status}
                  onChange={(e) => setNewUser({ ...newUser, status: e.target.value })}
                  required
                >
                  <option value="active">Aktif</option>
                  <option value="inactive">Pasif</option>
                </select>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label} htmlFor="avatar">Profil Fotoğrafı (URL)</label>
                <input
                  type="url"
                  id="avatar"
                  className={styles.input}
                  value={newUser.avatar}
                  onChange={(e) => setNewUser({ ...newUser, avatar: e.target.value })}
                  placeholder="https://..."
                />
              </div>
              <div className={styles.modalActions}>
                <button
                  type="button"
                  className={`${styles.button} ${styles.secondaryButton}`}
                  onClick={() => setShowAddModal(false)}
                >
                  İptal
                </button>
                <button
                  type="submit"
                  className={`${styles.button} ${styles.primaryButton}`}
                >
                  Kaydet
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header; 